module.exports = __webpack_public_path__ + "static/media/2020bw.037e4c74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2020bw.png
// module id = 790
// module chunks = 0